module.exports = __webpack_public_path__ + "img/组 472@2x.e1188ef3.png";